export const addressComponents = {
  cadastralIdentifier: {
    title: 'Cadastral identifier',
    type: 'simple-text',
    value: ''
  },
  buildingClass: {
    title: 'Building class',
    type: 'simple-text',
    value: ''
  },
  buildingType: {
    title: 'Building type',
    type: 'simple-text',
    value: ''
  },
  buildingCategory: {
    title: 'Established/new',
    type: 'simple-text',
    value: ''
  }
}
